<div *ngIf="urlContains('login') || urlContains('error')">
    <router-outlet></router-outlet>
</div>
<div *ngIf="!urlContains('login') && !urlContains('error')" class="page-wrapper bgd-grey" [class.open]="expandSidebar">
    <div >
        <app-global-header [(expandSidebar)]="expandSidebar"></app-global-header>
        <app-global-sidemenu  [(expandSidebar)]="expandSidebar"></app-global-sidemenu>
        <router-outlet></router-outlet>
    </div>
</div>
